import { render, staticRenderFns } from "./CustomsValue.vue?vue&type=template&id=64130423"
import script from "./CustomsValue.vue?vue&type=script&lang=js"
export * from "./CustomsValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports